<template>
  <div id="app">
    <dji-header>
      <template slot="primary-nav">
        <a href="https://www.justis.nl">Home</a>
        <router-link to="/" class="link-active">Rekentool</router-link>
      </template>
    </dji-header>
    <router-view />
    <div class="ribbon-bottom d-flex justify-content-center">
      <img class="ribbon-bottom-image" src="./assets/lint-footer.svg">
    </div>
  </div>
</template>

<script>
  import DjiHeader from './components/header.vue';

  export default {
    components: { DjiHeader },
    name: 'app',
    data(){ return {
      form : {
        datum_aanvraag: '',
        geboortedatum: '',
        datum_aanvang: '',
        datum_einde: ''
      }
    }}
  }
</script>

<style lang="scss">
  @import "./_common.scss";

  $ribbon-width: 4rem;

  @mixin ribbon() {
    position: relative;

    &:before {
      content: "";
      position: absolute;
      width: $ribbon-width;
      background: #ffffff;
      left: -$ribbon-width/2;
    }
  }

  .ribbon-bottom {
	  border-bottom: 1px solid #e6e6e6;

    .ribbon-bottom {
      width: 50px;
      height: 15px;
    }
  }

  .page-header {
    display: inline-block;
    position: relative;
  }

  .wrapper {
    max-width: 980px;
    margin: 0px auto;
    background-color: white;
  }

  .ro-text {
    display: flex;
    margin-left: 50%;
    height: 7rem;
    align-content: stretch;
    margin-bottom: 2rem;

    @include ribbon;
    &:before {
      height: 100%;
    }
  }

  .page-footer {
    height: 0rem;
    max-width: 980px;
    margin: 0px auto;
    background: white;

    @include ribbon();
    &:before {

      height: 4rem;
      bottom: 0;
      margin-left: 50%;

    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue